import { render, staticRenderFns } from "./YesNoNaComment.vue?vue&type=template&id=31594a1a&"
import script from "./YesNoNaComment.vue?vue&type=script&lang=js&"
export * from "./YesNoNaComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports